var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3582 11.6172H21.6414C24.7847 11.6172 27.3332 14.1095 27.3332 17.1834V23.7659C27.3332 26.8398 24.7847 29.3321 21.6414 29.3321H10.3582C7.21498 29.3321 4.6665 26.8398 4.6665 23.7659V17.1834C4.6665 14.1095 7.21498 11.6172 10.3582 11.6172ZM15.9931 23.1047C16.6569 23.1047 17.1853 22.588 17.1853 21.9387V18.9973C17.1853 18.3613 16.6569 17.8446 15.9931 17.8446C15.3427 17.8446 14.8143 18.3613 14.8143 18.9973V21.9387C14.8143 22.588 15.3427 23.1047 15.9931 23.1047Z",
    fill: "#3C7CF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.3635 9.86062V11.8216C22.8893 11.6891 22.388 11.6228 21.8731 11.6228H20.9925V9.86062C20.9925 7.17092 18.757 4.98472 16.0066 4.98472C13.2563 4.98472 11.0208 7.15767 11.0072 9.83412V11.6228H10.1401C9.61172 11.6228 9.11043 11.6891 8.63623 11.8348V9.86062C8.64978 5.8857 11.9421 2.66602 15.9795 2.66602C20.0712 2.66602 23.3635 5.8857 23.3635 9.86062Z",
    fill: "#3C7CF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4cd11d7ff6adb32351c31c756e98c741.svg";
export { ForwardRef as ReactComponent };